import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { DishTypeDetailsPage, DishTypesPage } from './pages'

const DishTypesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.DISH_TYPES.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={DishTypesPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.DISH_TYPE_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={DishTypeDetailsPage}
    />
  </Switch>
)

export default DishTypesRouter
